<span *ngIf="!isDoneTempRefSetting">{{setTempRef(noData)}}</span>
<ng-template #noData let-stylesObj="stylesObj" let-colNum="colNum" let-msg="msg">
  <tr [ngStyle]="stylesObj">
    <td [colSpan]="colNum">{{msg}}</td>
  </tr>
</ng-template>
